var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import PaymentVoucherService from '../../api/PaymentVoucherService';
import RegexStr from "@/common/RegexStr";
import Header from './components/Header.vue';
import viewImgList from '../shopAfterSales/components/viewImgList.vue';
import { cloneDeep } from 'lodash';
import { EBillType } from "@/enum/EBillType";
import { toDetail } from "@/helper/util";
var initCertFormData = {
    payment_voucher_id: '',
    status: 1,
    status_name: '',
    remark: '',
    purchase_order_order_icomment: ''
};
var PayCert = (function (_super) {
    __extends(PayCert, _super);
    function PayCert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = document.documentElement.clientHeight - 240;
        _this.viewImgDefaultIndex = 0;
        _this.certModalVisbile = false;
        _this.certModalType = 1;
        _this.mapStatusClass = {
            待确认: 'color-warning',
            已确认: 'color-success',
            已驳回: 'color-danger',
        };
        _this.pdfRegx = new RegExp(RegexStr.pdf);
        _this.certFormData = __assign({}, initCertFormData);
        _this.certImages = [];
        return _this;
    }
    PayCert.prototype.created = function () {
        this.service = PaymentVoucherService.getInstance();
    };
    PayCert.prototype.mounted = function () {
        this.getList();
    };
    PayCert.prototype.toOrderDetail = function (row) {
        toDetail(EBillType.PurOrder, row.order_id, this);
    };
    PayCert.prototype.lookBigImg = function (index, certImages) {
        var _this = this;
        this.viewImgDefaultIndex = index;
        this.certImages = certImages;
        this.$nextTick(function () {
            _this.$refs.viewImgList.show();
        });
    };
    PayCert.prototype.certModalConfirm = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (!res)
                return _this.$message.error('请填写所有必填字段');
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = __assign({}, _this.certFormData);
            _this.service
                .handleBill(params)
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success(res.data.msg || '操作成功');
                    _this.certModalHide();
                }
                _this.getList(_this.$refs.pagination.pager);
            })
                .catch(function (err) {
                console.log(err);
                loadingInstance.close();
                _this.$message.error(err.message);
            });
        });
    };
    PayCert.prototype.certModalShow = function (type, row) {
        this.certModalType = type;
        this.certImages = row.payment_voucher;
        this.certFormData = cloneDeep(row);
        this.certFormData.remark = row.remark;
        this.certFormData.purchase_order_order_icomment = row.purchase_order_order_icomment;
        if (type === 1) {
            this.certFormData.status_name = row.status_name;
        }
        else {
            this.certFormData.status = 1;
            this.certFormData.payment_voucher_id = row.payment_voucher_id;
        }
        this.certModalVisbile = true;
    };
    PayCert.prototype.certModalHide = function () {
        this.certModalVisbile = false;
        this.certFormData = __assign({}, initCertFormData);
    };
    PayCert.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        this.filter = filter;
        this.getList();
    };
    PayCert.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getList(Object.assign({}, this.filter, pager))
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data;
            _this.listData = DATA.data;
            _this.total = DATA.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    PayCert.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PayCert = __decorate([
        Component({
            components: {
                viewImgList: viewImgList,
                'list-header': Header,
            },
        })
    ], PayCert);
    return PayCert;
}(Vue));
export default PayCert;
